import styles from "./Loader.module.scss";

function SkeletonCard({ variant }) {
  return (
    <article className={`${styles.card} ${variant === "home" ? styles.home : ""}`}>
      <div className={styles.image}>
        <span className={`${styles.shimmer} ${styles.imageBlock}`} />
      </div>
      <div className={styles.body}>
        <div className={`${styles.shimmer} ${styles.line}`} />
        <div className={`${styles.shimmer} ${styles.line} ${styles.lineShort}`} />
        <div className={styles.button}>
          <span className={`${styles.shimmer} ${styles.buttonLine}`} />
        </div>
      </div>
    </article>
  );
}

function SkeletonCards({ count, variant }) {
  return Array.from({ length: count }, (_, index) => (
    <SkeletonCard key={index} variant={variant} />
  ));
}

export default function OfferSkeletons({
  count = 4,
  sections = 0,
  variant = "page",
  layout = "carousel",
}) {
  if (sections > 0) {
    return (
      <div className={styles.sections} role="status" aria-label="Cargando ofertas">
        {Array.from({ length: sections }, (_, section) => (
          <section className={styles.section} key={section}>
            <div className={styles.sectionHead}>
              <div className={styles.sectionTitleBox}>
                <span className={styles.sectionIcon} />
                <span className={`${styles.shimmer} ${styles.sectionTitle}`} />
              </div>
              <span className={`${styles.shimmer} ${styles.sectionLink}`} />
            </div>
            <div className={styles.carousel}>
              <div className={styles.track}>
                <SkeletonCards count={count} variant={variant} />
              </div>
            </div>
          </section>
        ))}
      </div>
    );
  }

  const frameClass =
    layout === "grid"
      ? styles.gridWrap
      : `${styles.carousel} ${variant === "home" ? styles.carouselHome : ""}`;

  return (
    <div className={frameClass} role="status" aria-label="Cargando ofertas">
      <div className={layout === "grid" ? styles.gridTrack : styles.track}>
        <SkeletonCards count={count} variant={variant} />
      </div>
    </div>
  );
}
